// Create Merchant
export const CREATE_MERCHANT_REQUEST = 'CREATE_MERCHANT_REQUEST';
export const CREATE_MERCHANT_DONE = 'CREATE_MERCHANT_DONE';
export const CREATE_MERCHANT_FAILED = 'CREATE_MERCHANT_FAILED';